var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCirlceBot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.182,
    height: 29.179,
    viewBox: "0 0 33.182 33.179",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bot",
    transform: "translate(0 -0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1_16_",
    transform: "translate(0 0.019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_17---Chat-Bot",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_96_",
    d: "M232.268,284.214a1.716,1.716,0,0,0,1.716-1.716h-3.432A1.716,1.716,0,0,0,232.268,284.214Z",
    transform: "translate(-215.676 -264.192)",
    fill: "#4c85f7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_29_",
    cx: 0.572,
    cy: 0.572,
    r: 0.572,
    transform: "translate(21.741 14.873)",
    fill: "#4c85f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_95_",
    d: "M128.378,167.739h-6.865a5.721,5.721,0,1,0,0,11.441h6.865a5.721,5.721,0,1,0,0-11.441Zm-9.153,6.293a1.716,1.716,0,1,1,1.716-1.716A1.716,1.716,0,0,1,119.225,174.032Zm5.721,4a2.86,2.86,0,0,1-2.86-2.86,1.148,1.148,0,0,1,1.144-1.144h3.432a1.148,1.148,0,0,1,1.144,1.144A2.86,2.86,0,0,1,124.946,178.036Zm5.721-4a1.716,1.716,0,1,1,1.716-1.716A1.716,1.716,0,0,1,130.667,174.032Z",
    transform: "translate(-108.354 -156.87)",
    fill: "#4c85f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_94_",
    d: "M164.834,408.372v3.089a16.389,16.389,0,0,1-6.55,1.482c-.1.006-.212.006-.315.006h-.023a16.582,16.582,0,0,1-6.842-1.487v-3.089a2.288,2.288,0,0,1,2.288-2.288h1.716v2.288a2.86,2.86,0,0,0,2.86,2.86,2.505,2.505,0,0,0,.292-.017,2.856,2.856,0,0,0,2.569-2.843v-2.288h1.716A2.288,2.288,0,0,1,164.834,408.372Z",
    transform: "translate(-141.377 -379.769)",
    fill: "#4c85f7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_28_",
    cx: 0.572,
    cy: 0.572,
    r: 0.572,
    transform: "translate(10.299 14.873)",
    fill: "#4c85f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_93_",
    d: "M230.552,408.373a1.716,1.716,0,1,0,3.432,0v-2.288h-3.432Z",
    transform: "translate(-215.676 -379.77)",
    fill: "#4c85f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_92_",
    d: "M34.182,16.609A16.586,16.586,0,0,1,25.6,31.139V28.622a3.432,3.432,0,0,0-2.094-3.158c4.382-1.5,6.67-4.908,6.67-10.1a13.988,13.988,0,0,0-1.144-5.623V6.312a.572.572,0,0,0-1.144,0V7.667a12.257,12.257,0,0,0-10.3-5.36,12.258,12.258,0,0,0-10.3,5.36V6.312a.572.572,0,0,0-.572-.572.585.585,0,0,0-.475.252.558.558,0,0,0-.1.32V9.738a13.987,13.987,0,0,0-1.144,5.623c0,5.194,2.288,8.6,6.67,10.1a3.432,3.432,0,0,0-2.094,3.158v2.517a16.59,16.59,0,1,1,24.6-14.53Z",
    transform: "translate(-1 -0.019)",
    fill: "#4c85f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_91_",
    d: "M91.924,52.981c-6.521,0-11.441,5.12-11.441,11.91,0,6.522,3.85,9.828,11.441,9.828s11.441-3.307,11.441-9.828C103.366,58.1,98.446,52.981,91.924,52.981Zm-.572,2.288H92.5a.572.572,0,1,1,0,1.144H91.352a.572.572,0,1,1,0-1.144Zm-1.144,1.716h3.432a.572.572,0,1,1,0,1.144H90.208a.572.572,0,0,1,0-1.144ZM95.357,73H88.492a6.865,6.865,0,0,1,0-13.73h6.865a6.865,6.865,0,0,1,0,13.73Z",
    transform: "translate(-75.332 -49.549)",
    fill: "#4c85f7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirlceBot);
export default __webpack_public_path__ + "static/media/cirlceBot.d31bdb13d5c108ded67c4ddfdf22a8ff.svg";
export { ForwardRef as ReactComponent };